module.exports = __webpack_public_path__ + "img/icon-ylswpay.a4f35ddf.png";